import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";

/**
 * Component to render in application details tab at How to Nominate page SBA
 */
const ApplicationDetails = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 px-5 py-4 pb-5 font-public-sans"
      data-testid="application-details-component"
    >
      <p className="mb-8">
        Applications for Emerging Enterprise Award and Emerging Enterprise
        Sustainability Award are now open
      </p>

      <Link
        to={RouteFactory.eeApplyNowPage}
        reloadDocument
        className="rounded-full bg-gray-850 px-10 py-2 font-poppins text-base font-medium text-white hover:bg-gray-675"
      >
        APPLY NOW
      </Link>
    </div>
  );
};

export default ApplicationDetails;
